// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2Xrzm","paramInput":"JobSimulator_paramInput__8YzJF","input":"JobSimulator_input__3qb-L"};